import { MutableRefObject, useCallback, useEffect, useState } from 'react';

import { useDeviceType } from '@braskai/ui-kit';

import { SNativeVideoPlayer } from './styled';
import { NativeVideoPlayerProps } from './types';

export const NativeVideoPlayer = ({ controls = true, muted = true, videoRef, ...rest }: NativeVideoPlayerProps) => {
  const [ref, setRefState] = useState<HTMLVideoElement | null>(null);
  const { isMobile } = useDeviceType();


  const setRef = useCallback(
    (node: HTMLVideoElement | null) => {
      setRefState(node);

      if (typeof videoRef === 'function') {
        videoRef(node);
      } else if (videoRef) {
        (videoRef as MutableRefObject<HTMLVideoElement | null>).current = node;
      }
    },
    [videoRef],
  );

  useEffect(() => {
    if (!ref || !isMobile) return;

    const observer = new IntersectionObserver(
      ([video]) => {
        if (video.isIntersecting) {
          setTimeout(() => {
            ref?.load();
          }, 500);

          observer.disconnect();
        }
      },
      {
        threshold: 0.5,
      },
    );

    observer.observe(ref);

    return () => observer.disconnect();
  }, [ref, isMobile]);

  return (
    <SNativeVideoPlayer
      component="video"
      controls={controls}
      controlsList="noplaybackrate nodownload"
      muted={muted}
      // @ts-expect-error valid
      ref={setRef}
      disablePictureInPicture
      playsInline
      {...rest}
    />
  );
};
